import styled from 'styled-components';

export const StyledMenus = styled.div`
    padding: 2rem;
`;
